import Container from "juis-components/Container.js";

export default function (html, ...args) {
    return new Container((container) => {
        container.innerHTML = html;
    }, ...args);
};
